<template>
  <div class="not-found-container">
    <div class="logo-section">
      <img src="@/assets/images/logo.png" alt="FZIOT Logo" class="logo" />
    </div>
    <div class="error-section">
      <div class="error-icon">
        <i class="iconfont icon-exclamation-circle">!</i>
      </div>
      <h1 class="error-title">404 Page Not Found</h1>
      <p class="error-description">
        The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound404',
};

</script>

<style scoped lang="less">
.not-found-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  padding: 0 20px;
  box-sizing: border-box;
}

.logo-section {
  margin-bottom: 40px;

  .logo {
    width: auto;
    height: 100px;
  }
}

.error-section {
  text-align: center;
  max-width: 500px;
}

.error-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e6f2ff;
  border-radius: 50%;

  .iconfont {
    font-size: 50px;
    color: #1890ff;
    font-weight: bold;
    font-style: normal;
  }
}

.error-title {
  font-size: 24px;
  font-weight: 600;
  color: #262626;
  margin: 0 0 16px;
}

.error-description {
  font-size: 14px;
  color: #8c8c8c;
  line-height: 1.5;
  margin: 0;
}
</style>
